import React, { useEffect, useRef } from 'react';
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaWhatsapp  } from 'react-icons/fa6';

function AboutUs() {
  const videoRef = useRef(null);
    
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1;
    }
  
    return () => {
      videoRef.current = null; // Cleanup
    };
  }, []);
  

  return (
    <div className=" min-h-screen">
      {/* Hero Section */}
      <div 
  className="relative w-full h-[500px] md:h-[500px] bg-no-repeat bg-center"
  style={{ 
    backgroundImage: "url('images/aboutus1.jpg')", 
    backgroundSize: "100% 100%", // Ensures full width & height without zoom
    backgroundPosition: "center" 
  }}
>
  {/* Dark Overlay for Readability */}
  <div className="absolute inset-0 bg-black opacity-50"></div>

  {/* Content Section */}
  <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white px-4">
    <h1 className="text-5xl md:text-7xl font-bold">About Us</h1>
    <p className="mt-2 text-lg md:text-xl text-gray-300">
      Professional solutions tailored to your needs.
    </p>
  </div>
</div>


      {/* About Us Content Section */}
      <div className="flex flex-col lg:flex-row 2xl:px-40 py-10 md:py-20 xl:gap-32">
         {/* Right Side - Text Content */}
  <div  className=" lg:hidden w-full lg:w-1/2 text-black p-4">
    <h2 className="text-center text-4xl md:text-5xl font-thin mb-4 md:mb-6">Who We Are</h2>
    <p className="text-2xl mb-4 text-justify font-thin  leading-9">
      We are a dedicated team committed to providing innovative logistics solutions that cater to various industries. Our mission is to streamline your business needs by offering cost-effective and reliable services. With years of experience, we understand the nuances of logistics, making us the ideal partner for your business.
    </p>
    <p className="text-2xl mb-4 text-justify font-thin leading-9">
      Our team works relentlessly to ensure that your goods reach their destination safely and on time. Whether you are looking for transportation, warehousing, or inventory management, we are here to assist you with tailored solutions.
    </p>
  </div>
  {/* Left Side - Image Grid (2x2) */}
  <div className="w-full lg:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-12 xl:gap-6 p-4">
  <div className="flex flex-col items-center md:items-start gap-8 lg:mt-20">
    <img src="images/case22.png" alt="Image 1" className="w-full max-w-xs md:max-w-sm 2xl:w-[250px] h-72 object-cover" />
    <img src="images/air2.jpg" alt="Image 2" className="w-full max-w-xs md:max-w-sm 2xl:w-[250px] h-72 object-cover" />
  </div>
  <div className="flex flex-col items-center md:items-start gap-8">
    <img src="images/nsc5.jpeg" alt="Image 3" className="w-full max-w-xs md:max-w-sm 2xl:w-[250px] h-72 object-cover" />
    <img src="images/shipping1.jpeg" alt="Image 4" className="w-full max-w-xs md:max-w-sm 2xl:w-[250px] h-72 object-cover" />
  </div>
</div>

  
        {/* Right Side - Text Content */}
        <div  className=" hidden lg:block w-full lg:w-1/2 text-black p-4">
    <h2 className="text-center text-3xl md:text-5xl font-thin mb-4 md:mt-12 md:mb-6">Who We Are</h2>
    <p className="text-2xl mb-4 text-justify font-thin  leading-9">
      We are a dedicated team committed to providing innovative logistics solutions that cater to various industries. Our mission is to streamline your business needs by offering cost-effective and reliable services. With years of experience, we understand the nuances of logistics, making us the ideal partner for your business.
    </p>
    <p className="text-2xl mb-4 text-justify font-thin leading-9">
      Our team works relentlessly to ensure that your goods reach their destination safely and on time. Whether you are looking for transportation, warehousing, or inventory management, we are here to assist you with tailored solutions.
    </p>
  </div>
</div>

<div className=" px-6 lg:px-10 2xl:px-60 bg-white">
  {/* Section Title */}
  <h2 className="text-center text-3xl md:text-5xl font-thin text-gray-900 mb-10">What We Do</h2>

  {/* 3 Cards Layout */}
  <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-6">
    
    {/* Card 1 - Transportation */}
    <div className="bg-slate-800 p-10 shadow-lg rounded-lg text-center">
      <h3 className="text-3xl font-thin mb-3 text-white">Efficient Transportation</h3>
      <p className="text-xl text-white font-thin">
        We provide fast and reliable transportation solutions to ensure your goods are delivered on time and in perfect condition.
      </p>
    </div>

    {/* Card 2 - Warehousing */}
    <div className="bg-slate-800 p-10 shadow-lg rounded-lg text-center">
      <h3 className="text-3xl font-thin mb-3 text-white">Secure Warehousing</h3>
      <p className="text-xl text-white font-thin">
        Our advanced storage facilities keep your inventory safe and organized, reducing logistics costs and delays.
      </p>
    </div>

    {/* Card 3 - Supply Chain Management */}
    <div className="bg-slate-800 p-10 shadow-lg rounded-lg text-center">
      <h3 className="text-3xl font-thin mb-3 text-white">Supply Chain Solutions</h3>
      <p className=" text-xl text-white font-thin">
        We optimize your supply chain to improve efficiency, reduce costs, and ensure smooth business operations.
      </p>
    </div>
  </div>
</div>


      {/* Contact Info Section */}
      <div className="flex flex-col items-center text-black p-4 space-y-8 xl:p-20 pt-12 md:pt-20 ">
        <h3 className="text-3xl md:text-5xl font-thin">Get In Touch</h3>
        <p className="text-center text-base lg:text-lg max-w-lg">
          We’d love to hear from you! Whether you have a question or want to collaborate, feel free to reach out to us anytime.
        </p>

        <div className="flex flex-wrap justify-center gap-8 md:gap-10">

          <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[280px]  p-8">
            <FontAwesomeIcon icon={faPhone} className="text-3xl text-black" />
            <h1>Phone</h1>
            <p>+44 208 051 5530</p>
          </div>

          <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[280px] p-8">
            <FontAwesomeIcon icon={faEnvelope} className="text-3xl text-black" />
            <h1>Email</h1>
            <p>info@1uklogistics.com</p>
          </div>

          <div className="flex flex-col items-center text-center gap-4 bg-slate-100 w-[280px] p-8">
  <FaWhatsapp  icon={FaWhatsapp} className="text-3xl text-black" />
  <h1>WhatsApp</h1>
  <p> +44 786 249 4152</p>
</div>
          <div className="flex flex-col items-center text-center gap-1 bg-slate-100 w-[280px] p-8">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-3xl text-black" />
            <h1>Regional Office</h1>
            <p>17 Harbour House, Cold Harbour Ln, Rainham RM13 9YA, United Kingdom</p>
          </div>

          <div className="flex flex-col items-center text-center gap-1 bg-slate-100 w-[280px]  p-8">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-3xl text-black" />
            <h1>Registered Office</h1>
            <p>Unit 204 Sierra Quebec Bravo, (Sqb) 77 Marsh Wall, London, England,E14 9SH</p>
          </div>
        </div>
      </div>

      <section className="relative  bg-cover bg-center  bg-no-repeat w-full  py-36 mt-20" style={{ backgroundImage: "url('images/nsc6.jpg') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-3xl md:text-[45px] mb-6 font-thin">For more information about our company and services, please contact us..</h2>
            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-200 text-black  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-slate-800 hover:text-white transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>
    </div>
  );
}

export default AboutUs;

// import React, { useEffect, useRef } from 'react';
// import {
//   faPhone,
//   faEnvelope,
//   faMapMarkerAlt,
// } from "@fortawesome/free-solid-svg-icons";

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { FaWhatsapp  } from 'react-icons/fa6';

// function AboutUs() {
//   const videoRef = useRef(null);
    
//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.playbackRate = 1;
//     }
  
//     return () => {
//       videoRef.current = null; // Cleanup
//     };
//   }, []);
  

//   return (
//     <div className="bg-[#f7f7f7] min-h-screen">
//       {/* Hero Section */}
//       <div
//         className="relative bg-cover bg-center h-[400px] md:h-[400px]"
//         style={{ backgroundImage: "url('images/aboutbg.jpg')" }}
//       >
//         <div className="absolute inset-0 bg-slate-900 "></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white px-4">
//           <h1 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-semibold">About Us</h1>
//           <p className="mt-2 text-base md:text-lg text-zinc-300">
//             Professional solutions tailored to your needs.
//           </p>
//         </div>
//       </div>

//       {/* About Us Content Section */}
//       <div className="flex flex-col md:flex-row lg:px-20 py-10 md:py-20 gap-10">
//         <div className="w-full lg:w-1/2 text-black p-4">
//           <h2 className="text-center text-2xl md:text-5xl font-bold mb-4 md:mb-6">Who We Are</h2>
//           <p className="text-lg mb-4 text-justify">
//             We are a dedicated team committed to providing innovative logistics solutions that cater to various industries. Our mission is to streamline your business needs by offering cost-effective and reliable services. With years of experience, we understand the nuances of logistics, making us the ideal partner for your business.
//           </p>
//           <p className="text-lg mb-4 text-justify">
//             Our team works relentlessly to ensure that your goods reach their destination safely and on time. Whether you are looking for transportation, warehousing, or inventory management, we are here to assist you with tailored solutions.
//           </p>
//         </div>

//         {/* Video Section */}
//         <div className="w-full lg:w-1/2 flex justify-center items-center p-4">
//           <div className="bg-black bg-opacity-10 backdrop-blur-md p-6 rounded-lg shadow-lg max-w-xl w-full">
//             <div className="aspect-w-16 aspect-h-9">
//               <video
//                 ref={videoRef}
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//                 className="w-full h-full object-cover"
//               >
//                 <source src="images/landingvideo.mp4" type="video/mp4" />
//                 Your browser does not support the video.
//               </video>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Contact Info Section */}
//       <div className="flex flex-col items-center text-black p-4 space-y-8 xl:p-20">
//         <h3 className="text-2xl md:text-5xl font-bold">Get In Touch</h3>
//         <p className="text-center text-base lg:text-lg max-w-lg">
//           We’d love to hear from you! Whether you have a question or want to collaborate, feel free to reach out to us anytime.
//         </p>

//         <div className="flex flex-wrap justify-center gap-8 md:gap-10">
//           <div className="flex flex-col items-center text-center gap-4">
//             <FontAwesomeIcon icon={faPhone} className="text-3xl text-black" />
//             <p>+44 208 051 5530</p>
//           </div>
//           <div className="flex flex-col items-center text-center gap-4">
//             <FontAwesomeIcon icon={faEnvelope} className="text-3xl text-black" />
//             <p>info@1uklogistics.com</p>
//           </div>
//           <div className="flex flex-col items-center text-center gap-4">
//   <FaWhatsapp  icon={FaWhatsapp} className="text-3xl text-black" />
//   <p>WhatsApp: +44 208 051 5530</p>
// </div>
//           <div className="flex flex-col items-center text-center gap-4">
//             <FontAwesomeIcon icon={faMapMarkerAlt} className="text-3xl text-black" />
//             <p>Harbour House, Coldharour Ln,<br/> Rainham RM13 9YA, United Kingdom</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AboutUs;
